module.exports = __webpack_public_path__ + "files/1435cd145cdae6ef1c25b8cf4155e700.png";